import { DragEndEvent } from "@dnd-kit/core";
import { arrayMove } from "@dnd-kit/sortable";

import { QuestionScope } from "../types";

type ScopedQuestion = { localId: string; scope: QuestionScope; isActiveOnForm: boolean };

type SetValueFn<T> = (name: "questions", value: T[], options?: { shouldDirty?: boolean }) => void;

export const createScopedQuestionDragHandler = <T extends ScopedQuestion>(
  allQuestions: T[],
  scope: QuestionScope,
  setValue: SetValueFn<T>
) => {
  return (event: DragEndEvent) => {
    const { active, over } = event;
    if (!over || active.id === over.id) {
      return;
    }

    const isInSection = (question: T) => question.isActiveOnForm && question.scope === scope;
    const sectionQuestions = allQuestions.filter(isInSection);

    const oldIndex = sectionQuestions.findIndex((q) => q.localId === active.id);
    const newIndex = sectionQuestions.findIndex((q) => q.localId === over.id);
    if (oldIndex === -1 || newIndex === -1 || oldIndex === newIndex) {
      return;
    }

    const reordered = arrayMove(sectionQuestions, oldIndex, newIndex);
    let cursor = 0;
    const nextQuestions = allQuestions.map((question) => (isInSection(question) ? reordered[cursor++] : question));
    setValue("questions", nextQuestions, { shouldDirty: true });
  };
};
